<template>
    <div>
        <template v-if="registrant.meals && registrant.meals.length > 0">
            <div class="mb-n3">
                <template v-for="meal in registrant.meals">
                    <div class="mb-3">
                        <h5 class="h6">{{ mealName(meal) }}</h5>
                        {{ meal.price_label }}
                        <template v-if="meal.price_amount">
                            : <strong>{{ meal.price_formatted_amount }}</strong>
                        </template>
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            registrant: Object,
            session: Object,
        },
        methods:{
            meal(id) {
                return this.session.meals?.find(meal => meal.id === id);
            },
            mealName(value) {
                return this.meal(value.id)?.name;
            },
        },
    }
</script>
